import type { Price } from "interfaces/product/product.types";

interface PriceToStringParams {
  price?: Price;
  noPriceText?: string;
  commissioningPrice?: number;
}

export const priceToString = ({
  price = {},
  noPriceText,
  commissioningPrice = 0,
}: PriceToStringParams): string | undefined => {
  const {
    centAmount = 0,
    preciseAmount = 0,
    currencyCode,
    fractionDigits = 0,
    type,
  } = price;

  if (
    !currencyCode ||
    (!centAmount && !commissioningPrice) ||
    (!Number(centAmount) && !commissioningPrice)
  ) {
    return noPriceText;
  }

  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: currencyCode,
  });

  const formatPrice = (): string => {
    let amount: number;

    if (type === "highPrecision") {
      amount = preciseAmount / 10 ** fractionDigits + commissioningPrice;
    } else {
      amount = centAmount / 10 ** fractionDigits + commissioningPrice;
    }

    return formatter.format(amount);
  };

  return formatPrice();
};
